var _style, _path, _path2, _polygon, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5F6B89;}\n\t.st1{fill:#EF7F5E;}\n\t.st2{fill:#E5F0F9;}\n\t.st3{fill:#FF5F5F;}\n\t.st4{fill:#9076FF;}\n\t.st5{fill:#527BFF;}\n\t.st6{fill:#5CF2CA;}\n\t.st7{fill:#5BDEF4;}\n\t.st8{fill:#7AED8C;}\n\t.st9{fill:#5CC7F2;}\n\t.st10{fill:#F2C65A;}\n\t.st11{fill:url(#SVGID_1_);}\n\t.st12{fill:url(#SVGID_2_);}\n\t.st13{fill:url(#SVGID_3_);}\n\t.st14{fill:#F45D9A;}\n\t.st15{opacity:0.35;fill:#37415E;}\n\t.st16{fill:#37415E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.75,6.97v11.68c0,0.42-0.34,0.75-0.75,0.75h-1.07V8.29L21.75,6.97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.75,5.35v1.01L12,13.39L2.25,6.36V5.35C2.25,4.93,2.59,4.6,3,4.6h0.11l8.74,6.3  c0.05,0.03,0.1,0.05,0.15,0.05s0.1-0.02,0.15-0.05l8.74-6.3H21C21.41,4.6,21.75,4.93,21.75,5.35z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "20.04,4.6 12,10.39 3.96,4.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.43,8.65V19.4H4.57V8.65l7.28,5.25c0.05,0.03,0.1,0.05,0.15,0.05s0.1-0.02,0.15-0.05L19.43,8.65z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.07,8.29V19.4H3c-0.41,0-0.75-0.33-0.75-0.75V6.97L4.07,8.29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M21,4.1H3c-0.69,0-1.25,0.56-1.25,1.25v13.3c0,0.69,0.56,1.25,1.25,1.25h18c0.69,0,1.25-0.56,1.25-1.25V5.35  C22.25,4.66,21.69,4.1,21,4.1z M20.04,4.6L12,10.39L3.96,4.6H20.04z M4.07,19.4H3c-0.41,0-0.75-0.33-0.75-0.75V6.97l1.82,1.32V19.4z   M19.43,19.4H4.57V8.65l7.28,5.25c0.05,0.03,0.1,0.05,0.15,0.05s0.1-0.02,0.15-0.05l7.28-5.25V19.4z M21.75,18.65  c0,0.42-0.34,0.75-0.75,0.75h-1.07V8.29l1.82-1.32V18.65z M21.75,6.36L12,13.39L2.25,6.36V5.35C2.25,4.93,2.59,4.6,3,4.6h0.11  l8.74,6.3c0.05,0.03,0.1,0.05,0.15,0.05s0.1-0.02,0.15-0.05l8.74-6.3H21c0.41,0,0.75,0.33,0.75,0.75V6.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.343078af281dd63b30f6a9d1989f6621.svg";
export { ForwardRef as ReactComponent };